import ko from 'knockout';
import MicroModal from 'micromodal';

class ShareLinkViewModel {
    public copied = ko.observable<boolean>(false);

    public showModal = (): void => {
        MicroModal.show('share-link-modal');
    };

    public copyLink = (): void => {
        const input = document.getElementById(
            'share-link-input',
        ) as HTMLInputElement;
        input.select();

        try {
            this.copied(document.execCommand('copy'));
        } catch {
            this.copied(false);
        }
    };
}

export function ShareLink(): void {
    ko.applyBindings(
        new ShareLinkViewModel(),
        document.getElementById('share-link'),
    );
}
